import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import theme from '@theme/FolxTheme';

export const SectionLabel = styled(BasicText)`
	margin-bottom: ${theme.spacing.sm};
`;
